import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { BasicButton } from "../../../../../theme/Component/BasicButton";
import { SelectQualityMeasurementInspections } from "../../../QualityMeasurementInspections/SelectQualityMeasurementInspections";
import { SelectQualityMeasurementInspectionsItems } from "../../../QualityMeasurementInspections/QualityMeasurementInspectionsItems/SelectQualityMeasurementInspectionsItems";
import { PrintJson } from "../../../../../theme/Component/PrintJson";
import { SelectQualityGarment } from "../../../QualityGarment/SelectQualityGarment";

type ItemSeleccionado = {
    ID: number;
    CodeCota: string;
    Name: string;

    IDTalla: number;
    RenderTalla: string;
    ToleranceValue: number;
    Tolerance: number;
    Type: number;

    Value: number;
    Satisfy: boolean;
};

interface Props {
    jsonProps?: string;
    onChange?: (value: string) => void;
    labelSelector?: string;
}

export const ListSamplesCotaInspections = ({ jsonProps = "", onChange, labelSelector }: Props) => {
    const [current, setCurrent] = useState<Partial<ItemSeleccionado>>({});
    const [lista, setLista] = useState<ItemSeleccionado[]>([]);

    useEffect(() => {
        try {
            if (jsonProps && jsonProps.trim() !== "") {
                const parsed = JSON.parse(jsonProps);
                if (Array.isArray(parsed)) {
                    setLista(parsed as ItemSeleccionado[]);
                } else {
                    toast.error("El formato de jsonProps no es una lista válida.");
                    setLista([]);
                }
            } else {
                setLista([]);
            }
        } catch {
            toast.error("Error al parsear jsonProps.");
            setLista([]);
        }
    }, []);

    useEffect(() => {
        onChange?.(JSON.stringify(lista));
    }, [lista]);

    const isNum = (n: unknown): n is number => typeof n === "number" && !Number.isNaN(n);

    const create = () => {
        const { ID, IDTalla, ToleranceValue, Tolerance, Value, Type } = current;
        if (
            !isNum(ID) ||
            !isNum(IDTalla) ||
            !isNum(ToleranceValue) ||
            !isNum(Value) ||
            !isNum(Type)
        ) {
            toast.error("Validar datos de Creación");
            return;
        }

        if (lista.some(i => i.ID === ID)) {
            toast.warn("Este dato ya está agregado.");
            return;
        }

        let Satisfy = false;

        if (Type === 100) {
            // mínimo
            Satisfy = Value >= ToleranceValue;
        } else if (Type === 101) {
            // máximo
            Satisfy = Value <= ToleranceValue;
        } else if (Type === 102) {
            // tolerancia
            const min = ToleranceValue - Tolerance;
            const max = ToleranceValue + Tolerance;
            Satisfy = Value >= min && Value <= max;
        }

        setLista(prev => [
            ...prev,
            {
                ID,
                CodeCota: current.CodeCota ?? "",
                Name: current.Name ?? "",
                IDTalla,
                RenderTalla: current.RenderTalla ?? "",
                ToleranceValue,
                Tolerance,
                Value,
                Satisfy,
                Type
            }
        ]);
    };

    const deleteItem = (index: number) => {
        setLista(prev => prev.filter((_, i) => i !== index));
    };

    const renderValores = (item: ItemSeleccionado) => {
        if (item.Type === 100) {
            return (
                <>
                    Mínimo permitido: {item.ToleranceValue} <br />
                    Medida obtenida: {item.Value}
                </>
            );
        } else if (item.Type === 101) {
            return (
                <>
                    Máximo permitido: {item.ToleranceValue} <br />
                    Medida obtenida: {item.Value}
                </>
            );
        } else {
            return (
                <>
                    Cota: {item.ToleranceValue} <br />
                    Tolerancia: {item.Tolerance} <br />
                    Medida obtenida: {item.Value}
                </>
            );
        }
    };

    const [garment, setGarment] = useState<number>();

    return (
        <div className="row">
            <div className="col-md-12 mb-3">
                <div className="row">
                    <div className="col-md-4">
                        <SelectQualityGarment label="Prenda" idSelector={garment} onChange={(e) => { setGarment(e) }} />
                    </div>
                    <div className="col-md-4">
                        <label>{labelSelector}</label>
                        <SelectQualityMeasurementInspections
                            idSelector={current.ID as number}
                            returnType="Object"
                            idGarment={garment}
                            onChange={(e: any) =>
                                setCurrent({
                                    ...current,
                                    ID: e.IDQualityMeasurementInspections,
                                    Name: e.Name,
                                    CodeCota: e.CodeMeasurement
                                })
                            }
                            label=" "
                        />
                    </div>

                    {isNum(current.ID) && (
                        <div className="col-md-4">
                            <label>Talla</label>
                            <SelectQualityMeasurementInspectionsItems
                                idQualittyInspections={current.ID}
                                idSelector={current.IDTalla as number}
                                returnType="Object"
                                onChange={(e: any) =>
                                    setCurrent({
                                        ...current,
                                        IDTalla: e.IDQualityMeasurementInspectionsItems,
                                        RenderTalla: e.ConstantName,
                                        ToleranceValue: e.DefaultValue,
                                        Tolerance: e.Tolerance,
                                        Type: e.IDTypeTolerance
                                    })
                                }
                                label=" "
                            />
                        </div>
                    )}

                    <div className="col-md-3">
                        <label>Medida Obtenida</label>
                        <input
                            type="number"
                            value={isNum(current.Value) ? current.Value : ""}
                            onChange={(e) => {
                                const v = e.target.value;
                                const value = v === "" ? undefined : Number(v);
                                setCurrent({
                                    ...current,
                                    Value: Number.isNaN(value as number)
                                        ? undefined
                                        : (value as number)
                                });
                            }}
                            className="form-control"
                        />
                    </div>

                    <div className="col-md-2">
                        <BasicButton useMargin eventClick={create} icon="ri-file-add-line">
                            Agregar
                        </BasicButton>
                    </div>
                </div>
            </div>

            <div className="col-md-12">
                <table className="table table-bordered table-hover">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Nombre</th>
                            <th>Valores</th>
                            <th>¿Cumple?</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {lista.map((item, index) => (
                            <tr key={`${item.ID}-${index}`}>
                                <td>{index + 1}</td>
                                <td>
                                    {item.CodeCota} - {item.Name} / {item.RenderTalla}
                                </td>
                                <td>{renderValores(item)}</td>
                                <td>{item.Satisfy ? "Sí" : "No"}</td>
                                <td>
                                    <BasicButton
                                        eventClick={() => deleteItem(index)}
                                        icon="ri-delete-bin-line"
                                    >
                                        Eliminar
                                    </BasicButton>
                                </td>
                            </tr>
                        ))}

                        {lista.length === 0 && (
                            <tr>
                                <td colSpan={5} className="text-center">
                                    No hay elementos agregados
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};
